// src/api/signupAPI.ts
import axios, { AxiosError } from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? "http://localhost:3001";

// Separate instance for auth requests (no token needed)
const authApiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

export interface SignupDTO {
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  password: string;
}

export interface ApiResponse<T = unknown> {
  status: boolean;
  message: string;
  data?: T;
  errors?: Record<string, string[]> | string;
  path?: string;
  method?: string;
  timestamp?: string;
}

export interface SignupResponse {
  uuid: string;
  email: string;
}

export async function signupAPI(
  dto: SignupDTO
): Promise<ApiResponse<SignupResponse>> {
  try {
    console.log('Making signup request to:', `${API_BASE_URL}/auth/signup`);
    console.log('Request payload:', dto);
    
    const { data } = await authApiClient.post<ApiResponse<SignupResponse>>(
      "/auth/signup",
      dto
    );
    console.log("Signup API response:", data);
    return data;
  } catch (error) {
    console.error('Signup API error:', error);
    const err = error as AxiosError<ApiResponse>;

    if (err.response?.data) {
      console.error('Error response data:', err.response.data);
      // Backend always follows ApiResponse
      return err.response.data as ApiResponse<SignupResponse>;
    }

    if (err.code === 'ECONNREFUSED' || err.code === 'NETWORK_ERROR') {
      return {
        status: false,
        message: "Unable to connect to server. Please check your internet connection.",
      };
    }

    if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
      return {
        status: false,
        message: "Request timed out. Please try again.",
      };
    }

    return {
      status: false,
      message: err.message || "Network error. Please try again later.",
    };
  }
}
